import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchMerchantFiles = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("file")}/all`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "fileName", "fileTypeId");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_files);
  }
};

export const fetchFileTypes = async (lng = "english", params) => {
  const { listType, businessCategoryId } = params || {};

  const { accessToken } = await getStorage();

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }
    const options = {
      method: "GET",
      url: `${api("file")}/types/business`,
      params: {
        businessCategoryId,
      },
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "type", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_files);
  }
};

export const fetchUserFiles = async (lng = "english", params) => {
  const { listType } = params || {};

  const { accessToken } = await getStorage();

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + accessToken,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("file")}/all`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "fileType", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_files);
  }
};

export const viewUploadedFile = async (lng = "english", params) => {
  const { fileId } = params || {};

  const { accessToken } = await getStorage();

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }
    const options = {
      method: "GET",
      url: `${api("file")}/view?fid=${fileId}`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_view_uploaded_file);
  }
};

export const fetchBusinessRequiredFiles = async (lng = "english", params) => {
  const { profileUnitId } = params || {};

  const { accessToken, businessCategoryId, countryId } = await getStorage();

  if (!businessCategoryId || !countryId || !profileUnitId) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }
    const options = {
      method: "GET",
      url: `${api(
        "file"
      )}/types/business?businessCategoryId=${businessCategoryId}&countryId=${countryId}&profileUnitId=${profileUnitId}`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    return data.data.map((el) => {
      return {
        profileUnitId,
        ...el,
      };
    });
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_required_files);
  }
};
